import React, { useEffect, useCallback, useRef } from 'react';
import { InputGroup, InputLeftElement, Input } from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';
import { useLocation } from 'react-router-dom'; // Import useLocation
import colors from "common/theme/foundations/colors";
const CustomSearchInput = React.memo(({
  allData,
  setSearchbox,
  setDisplaySearchData,
  searchbox,
  handleSearchChange,
  dataColumn,
  onSearch,
  setGetTagValues,
  setGopageValue,

  isKanban = false,
  source = '',
  setIsLoading

}) => {
  const debounceTimeout = useRef(null);
  const inputRef = useRef(null);
  const location = useLocation();

  const preserveFocus = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    const savedSearchTerm = localStorage.getItem('searchTerm');

    if (savedSearchTerm) {
      setSearchbox(savedSearchTerm);
    }
  }, [setSearchbox]);

  useEffect(() => {
    // Only clear search box when route changes to a different module
    // Don't clear when navigating within the same module (like job openings)
    const currentModule = location.pathname.split('/')[1]; // e.g., 'recruitment'
    const savedModule = localStorage.getItem('currentModule');
    
    if (savedModule && savedModule !== currentModule) {
      setSearchbox('');
      setDisplaySearchData(false);
      setGetTagValues([]);
      localStorage.removeItem('searchTerm');
    }
    
    localStorage.setItem('currentModule', currentModule);
  }, [location.pathname]);

  const handleInputChange = useCallback((e) => {
    const originalValue = e.target.value || '';
    const lowercasedValue = originalValue.toLowerCase();

    setSearchbox(originalValue);
    if (setIsLoading) setIsLoading(true);
    setGetTagValues([]);

    const wasFocused = document.activeElement === inputRef.current;

    if (!originalValue && setGopageValue) {
      setGopageValue(1);
    }

    localStorage.setItem('searchTerm', originalValue);

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    if (originalValue === '') {
      if (handleSearchChange) {
        handleSearchChange(originalValue);
      }
    } else {
      debounceTimeout.current = setTimeout(() => {
        if (handleSearchChange) {
          handleSearchChange(originalValue);
        }

      }, 500);
    }
  }, [
    handleSearchChange,
    setSearchbox,
    setGetTagValues,
    setGopageValue,
    preserveFocus
  ]);

  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  return (
    <InputGroup
      width={'100%'}
      maxWidth={'251px'}
      mx={{ sm: 0, md: 3 }}
      my={{ sm: "8px", md: "0" }}
      className="search-input"
    >
      <InputLeftElement
        size="sm"
        top="-3px"
        pointerEvents="none"
        zIndex="0"
        children={<SearchIcon className="customSearchIcon" color={colors.iconDark} />}
      />
      <Input
        ref={inputRef}
        type="text"
        size="sm"
        fontSize="sm"
        value={searchbox}
        onChange={handleInputChange}
        fontWeight="400"
        placeholder="Search"
        borderRadius="16px"
      />
    </InputGroup>
  );
});

export default CustomSearchInput;
